/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

import { ProfileStatusManager } from '../services/manager';

import { profileActions } from './definition';
import { IFile, IFileU, IJoinProfile, IProfile } from '../interfaces/profile';
import { addTeam, getProfile, getSignedUrl, updateProfile, uploadFile } from '../services/profile';

function profileIsLoading() {
    return {
        type: profileActions.PROFILE_IS_LOADING,
    };
}

const profileReset = () => {
    return {
        type: profileActions.PROFILE_RESET,
    };
};

function profileError(e: string) {
    return {
        type: profileActions.PROFILE_ERROR,
        error: e,
        data: e,
    };
}

function profileSet(profile: any) {
    return {
        type: profileActions.PROFILE,
        data: profile,
    };
}

/**
 * Reducer to rest a profiles
 * @param velues Data to reset profiles
 */
export const resetStateProfile = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(profileReset());
    };
};

/**
 * Reducer to rest a profiles
 * @param velues Data to reset profiles
 */
export const resetProfileReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(profileReset());
    };
};

/**
 * Reducer to reset Profiles
 * @param velues Velues to reset profiles
 */
export const resetProfile = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(profileReset());
    };
};

/**
 * Reducer to get a profile by id
 * @param id Id of profile to find
 */
export const getUserProfile = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(profileIsLoading());
        try {
            const response = await getProfile();
            if (response?.statusCode === ProfileStatusManager.USER_PROFILE_GET && response.data) {
                dispatch(profileSet(response));
            } else {
                dispatch(profileError('Could not get profile'));
            }
        } catch (error: any) {
            dispatch(profileError('No se pudo obtener el profile'));
        }
    };
};

/**
 * Reducer  profile
 * @param values Data to create a profile
 */
export const updateUserProfile = (values: IProfile) => {
    //console.log({ values })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(profileIsLoading());
        try {
            const profile = await updateProfile(values);
            if (profile?.statusCode === 'USER_PROFILE_UPDATED') {
                dispatch(profileSet(profile));
                //getUserProfile()
            } else {
                dispatch(profileError('No se pudo crear el perfil: ' + profile?.statusCode));
            }
        } catch (error: any) {
            //console.log('aqui llegue error', values);
            dispatch(profileError('No se pudo crear el perfil'));
        }
    };
};

/**
 * Reducer  add guest profile
 * @param velues Data to create a add guest profile
 */
export const addTeamProfile = (velues: IJoinProfile) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(profileIsLoading());
            console.log('fuera velues', velues);
            const profile = await addTeam(velues);
            if (profile?.statusCode === 'PROFILE_ADD_TEAM_SUCCESSFULLY') {
                dispatch(profileSet(profile));
            } else {
                dispatch(profileError('No se pudo agregar el equipo del perfil'));
            }
        } catch (error: any) {
            if (error.response && error.response.data) {
                dispatch(profileError('No se pudo agregar el equipo al perfil'));
                return;
            } else {
                dispatch(profileError('No se pudo agregar el equipo al perfil'));
                return;
            }
        }
    };
};

/**
 * Reducer to get getSignedUrlValid
 * @param file File url valid
 */
export const getSignedUrlValid = (file: IFile) => {
    return async (dispatch: Dispatch<any>): Promise<any> => {
        try {
            const response = await getSignedUrl(file);
            if (response?.statusCode === 'FILE_UPLOAD_PATH_GETED') {
                return response.data;
            }
        } catch (error) {
            dispatch(profileError('Error al subir la imagen'));
        }
    };
};

/**
 * Reducer to update a club
 * @param values Values to update a club
 */
export const uploadFileUrl = (path: string, contentType: string, file: IFileU) => {
    return async (): Promise<string> => {
        const response = await uploadFile(path, contentType, file);
        return response.statusText;
    };
};
